<script lang="ts">
	import { cn } from '$lib/utils';
	import { onDestroy } from 'svelte';
	import { inview } from 'svelte-inview';

	const options = {};
	let activeId = 0;
	let intervalId: number | undefined;
	let innerWidth: number;

	function startAnimation() {
		activeId = 0;

		clearInterval(intervalId);
		intervalId = setInterval(() => {
			if (activeId !== 6) {
				activeId++;
			}
		}, 450);
	}

	onDestroy(() => {
		clearInterval(intervalId);
	});
</script>

<svelte:window bind:innerWidth />
<div
	class="border-darkTertiary bg-darkSecondary hover:border-darkQuaternary relative h-80 w-full overflow-hidden rounded-lg border p-6 shadow-sm transition-all lg:h-96"
	use:inview={options}
	on:inview_enter={() => {
		startAnimation();
	}}
	role="figure"
>
	<div class="card-spotlight -top-32 z-0 aspect-square h-80" />
	<div class="grid h-full w-full grid-rows-5 items-center justify-center gap-4">
		<div class="row-span-3 flex h-full w-full flex-row items-center justify-center">
			{#each Array(innerWidth < 1000 ? 3 : 6).fill(null) as _, i}
				<div
					class={cn(
						'border-darkTertiary bg-darkPrimary flex items-center justify-center rounded-lg border transition-all duration-700',
						activeId >= i && `bg-item-${i + 1}`,
						activeId === i && `mr-2 h-14 w-14 first:mr-4 first:h-12 first:w-12 last:mr-0`,
						activeId !== i && `mr-4 h-12 w-12 last:mr-0`
					)}
				>
					{#if activeId < i}
						{i + 1}
					{/if}
				</div>
			{/each}
		</div>
		<div
			class="row-span-2 mx-auto flex h-full w-full max-w-sm flex-col items-center justify-center gap-2 text-center"
		>
			<h3 class="text-xl font-normal">Champion & Matchup Builds</h3>
			<p class="text-lightTertiary max-w-xs">
				Get data-proven build recommendations for any champion and matchup.
			</p>
		</div>
	</div>
</div>
